export { default as addresses } from './addresses.json';
export * from '../generated/abis';
